// extracted by mini-css-extract-plugin
export default {"BasicButtonContainer":"BasicButton_BasicButtonContainer__5W+ls","BasicButton":"BasicButton_BasicButton__vKpw-","DisabledButton":"BasicButton_DisabledButton__XVpXR"};